import { render } from "./set-new-password.vue?vue&type=template&id=fcb5284a&scoped=true"
import script from "./set-new-password.vue?vue&type=script&lang=js"
export * from "./set-new-password.vue?vue&type=script&lang=js"

import "./set-new-password.vue?vue&type=style&index=0&id=fcb5284a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb5284a"]])

export default __exports__